// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import RoutingEnum from 'constants/RoutingEnum';

import Listener from 'PMT/flux/Listener';

import { Events, Config } from 'constants';

import {
  RouteAction,
  RestaurantAction
} from 'actions';

import {
  RestaurantStore,
  ProAccountStore
} from 'stores';

import {
  RestaurantsGroup
} from 'PMT/entities/security';

// -- views
import ChooseRestaurantsGroupModal from './ChooseRestaurantsGroupModal';

export default class ChooseRestaurantsGroupListMenu extends Component {

  state = {
    displayModal: false
  };

  onDisplayModal = () => {
    const restaurant = RestaurantStore.getRestaurant;
    const mainRestaurantGroupList = RestaurantStore.getRestaurantsGroup();

    if (mainRestaurantGroupList.isOnlyForTheRestaurantWithId(restaurant.id)) {
      return;
    }

    this.setState({
      displayModal: true
    });
  }

  onHideModal = () => {
    this.setState({
      displayModal: false
    });
  }

  //
  // Renderers
  //

  renderModal() {
    if (!this.state.displayModal) {
      return (null);
    }
    return (
      <div>
        <ChooseRestaurantsGroupModal
          show
          onHide={this.onHideModal}
        />
      </div>
    );
  }

  render() {
    const restaurant = RestaurantStore.getRestaurant();
    const restaurantGroupList = RestaurantStore.getSelectedRestaurantsGroup();

    if (_.isNull(restaurant) || _.isNull(restaurantGroupList)) {
      return (null);
    }

    let restaurantName = '';
    if (!_.isNull(restaurant)) {
      restaurantName = restaurant.name
    }

    let restaurantGroupName = '';
    if (!_.isNull(restaurantGroupList)) {
      restaurantGroupName = restaurantGroupList.name;
    }

    let roleName = '';
    const meAccount = ProAccountStore.getMeAccount();
    if (!_.isNull(meAccount) && !_.isNull(meAccount.domainsList)
    && meAccount.domainsList.numberOfDomains() > 0) {
      roleName = ProAccountStore.getSelectedProDomain().role.name;
    }

    // we don't want to display AAA - AAA, but AAA
    if (restaurantGroupList.isOnlyForTheRestaurantWithId(restaurant.id)) {
      restaurantGroupName = '';
    }

    return (
      <li
        onClick={this.onDisplayModal}
      >
        <a href="#">
          {roleName}
          {!_.isEmpty(roleName) &&
            <span>&nbsp;-&nbsp;</span>
          }
          {restaurantGroupName}
          {!_.isEmpty(restaurantGroupName) &&
            <span>&nbsp;-&nbsp;</span>
          }
          {restaurantName}
          {/* {restaurantName} */}
        </a>
        {this.renderModal()}
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/header/components/ChooseRestaurantsGroupListMenu.js